import script from "./joinus.vue?vue&type=script&setup=true&lang=js"
export * from "./joinus.vue?vue&type=script&setup=true&lang=js"

import "./joinus.vue?vue&type=style&index=0&id=77aab352&lang=scss&scoped=true"

import exportComponent from "E:\\xm\\siggraph\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77aab352"]])

export default __exports__